import Api from 'requestapijs';
import { HEADER, API_URL } from '../config';
import { AssignWorkMutationInput, AssignWorkMutationPayload } from '../../schema';
import { Inject } from '../helpers';
import { UserService } from './userService';
import { mutation } from '../components/assignWork/constant';

export class AssignWorkService {
  static instance: AssignWorkService;

  @Inject userService: UserService;

  constructor() {
    if (AssignWorkService.instance) {
      return AssignWorkService.instance;
    } else {
      AssignWorkService.instance = this;
    }
  }

  add(data: AssignWorkMutationInput, onSuccess: (reponse) => void, onError: (response) => void) {
    Api.graphql<{ input: AssignWorkMutationInput }, AssignWorkMutationPayload>(
      API_URL,
      { input: { ...data, supervisor: this.userService.user$.getValue().id } },
      mutation,
      HEADER,
      (response) => {
        onSuccess(response);
      },
      (error) => {
        onError(error);
      },
    );
  }
}
